const minimalStock = {
  toggleAddToCartButtons() {
    const cartItemQuantityInputs = document.querySelectorAll('.quantity__input');
    if (cartItemQuantityInputs.length) {
      cartItemQuantityInputs.forEach((input) => {
        console.log(input.dataset);
        const variantId = input.dataset.quantityVariantId;
        const cartQuantity = parseInt(input.dataset.cartQuantity, 10) || 0;
        const max = parseInt(input.max, 10) || 0;
        const addToCartButtons = document.querySelectorAll(`button[name="add"][data-variant-id="${variantId}"]`);
        if (addToCartButtons.length) {
          if (cartQuantity >= max) {
            addToCartButtons.forEach((button) => (button.disabled = true));
          } else {
            addToCartButtons.forEach((button) => (button.disabled = false));
          }
        }
      });
    }
  },
  activateButtonsForRemovedItems(items) {
    if (!items || !Array.isArray(items) || items.length === 0) {
      return;
    }
    items.forEach((item) => {
      const variantId = item.variant_id;
      const addToCartButtons = document.querySelectorAll(`button[name="add"][data-variant-id="${variantId}"]`);
      if (addToCartButtons.length) {
        addToCartButtons.forEach((button) => {
          button.disabled = false;
        });
      }
    });
  },
};

document.addEventListener('DOMContentLoaded', () => {
  minimalStock.toggleAddToCartButtons();
});

document.addEventListener('cart:updated', (e) => {
  minimalStock.toggleAddToCartButtons();
  const cartData = e.detail?.cartData;

  if (cartData) {
    const itemsRemoved = cartData.items_removed || [];
    const currentItems = cartData.items || [];
    const currentVariantIds = currentItems.map((item) => item.variant_id);
    const trulyRemovedItems = itemsRemoved.filter((removedItem) => !currentVariantIds.includes(removedItem.variant_id));
    minimalStock.activateButtonsForRemovedItems(trulyRemovedItems);
  }
});
